<div *ngIf="documentUrl" class="element">
  <div class="close-icon" (click)="closeDialog()">
    <i class="pi pi-times-circle"></i>
  </div>

  <div *ngIf="isPdf(documentUrl); else imageViewer">
    <pdf-viewer
      [src]="safeUrl"
      [render-text]="true"
      [original-size]="false"
      style="display: block; width: 100%; height: 100%;"
      (after-load-complete)="pdfLoaded($event)">
    </pdf-viewer>
  </div>

  <ng-template #imageViewer>
    <img [src]="documentUrl" alt="Document Image">
  </ng-template>

</div>
<div class="button-container">
  <p-button label="Close" size="small" (onClick)="closeDialog()" [text]="true" [raised]="true" />
</div>
